/** @format */
import React, { useRef } from "react";
import { useUserContext } from "../context/UserContext.js";

import { awsUrl} from "../helpers";
import { gsap } from "../gsap";
import { SplitText } from "../gsap/SplitText";
import { useGSAP } from "../gsap/react";
import { FlyThrough } from "./UnlockedPortal/Modules";

gsap.registerPlugin(SplitText, useGSAP);

const ShipView = () => {

  const headlineShipsRef = useRef();
  const headlineTl = useRef();
  const { isTrade } = useUserContext();
  
  useGSAP(() => {
    let titleRef = new SplitText("#headline-ships", { type: "chars, words" });
    let captionRef = new SplitText(".lead", { type: "lines" });

    const splitRevert = () => {
      captionRef.revert();
    };

    const splitRevert1 = () => {
      titleRef.revert();
    };

    headlineTl.current = gsap
      .timeline({
        scrollTrigger: {
          start: "top center",
          trigger: "#carnival-ships",
          // markers: true
        }
      })
      .from(
        titleRef.chars,
        {
          duration: 0.65,
          x: 10,
          autoAlpha: 0,
          stagger: 0.03,
          onComplete: splitRevert1
        },
        "<"
      )
      .from(
        captionRef.lines,
        {
          duration: 0.75,
          y: 20,
          autoAlpha: 0,
          stagger: 0.05,
          onComplete: splitRevert
        },
        ">"
      );
  }, {});

  return (
    <section
      id="carnival-ships"
      className="relative bg-dark-blue lg:min-h-screen text-white mt-[150px] lg:mt-0"
      data-tag="section_6_sliders"
      data-pixel="carni044+unique"
    >
      <div className="absolute -top-[150px] lg:top-[40px] left-0 w-full z-10 pointer-events-none">
        {!isTrade ? (
          <div>
            {" "}
            <h2
              ref={headlineShipsRef}
              id="headline-ships"
              className="text-[32px] leading-[38px] lg:text-[45px] text-millik drop-shadow-2xl lg:leading-[65px] text-center mt-[20px] lg:mt-[38px] mb-3 pointer-events-none font-bold"
              aria-label="Plan your Carnival vacation today"
            >
              <span aria-hidden="true">Plan your Carnival vacation&nbsp;today</span>
            </h2>
            <p
              className="lead text-[19px] leading-[25px] lg:text-[25px] lg:leading-[34px] w-full mx-auto max-w-[580px] text-center px-6 lg:px-4 mt-2 pointer-events-none"
              aria-label="Explore sailings to Celebration Key and the Carnival ships that’ll take you
              to paradise."
            >
              <span aria-hidden="true">
                {" "}
                Explore sailings to Celebration Key and the Carnival ships that’ll take you
                to&nbsp;paradise.
              </span>

              <p className="sr-only" aria-hidden="true">
                {" "}
                Explore sailings to Celebration Key and the Carnival ships that’ll take you
                to&nbsp;paradise.
              </p>
            </p>
          </div>
        ) : (
          <div>
            <h2
              ref={headlineShipsRef}
              id="headline-ships"
              className="text-[32px] leading-[38px] lg:text-[45px] text-millik drop-shadow-2xl lg:leading-[65px] text-center mt-[20px] lg:mt-[38px] mb-3 pointer-events-none font-bold"
              aria-label="Plan your Carnival vacation with a Travel Advisor"
            >
              <span aria-hidden="true">
                {" "}
                Plan your Carnival vacation with a Travel&nbsp;Advisor
              </span>
            </h2>
            <p
              className="lead text-[19px] leading-[25px] lg:text-[25px] lg:leading-[34px] w-full mx-auto max-w-[580px] text-center px-6 lg:px-4 mt-2 pointer-events-none"
              aria-hidden="true"
            >
              Call your Travel Advisor today to explore sailings to Celebration Key and the Carnival
              ships that'll take you to&nbsp;paradise.
              <p className="sr-only">
                {" "}
                Call your Travel Advisor today to explore sailings to Celebration Key and the
                Carnival ships that'll take you to&nbsp;paradise.
              </p>
            </p>
          </div>
        )}
      </div>
      <FlyThrough
        media={`image`}
        imgSrc={`${awsUrl}/media/CarnivalCK`}
        isPlaying={false}
       headline={``}></FlyThrough>
      {/*<div className="absolute left-1/2 -translate-x-1/2 bottom-[13%] z-[102] btn">*/}
      {/*  {" "}*/}
      {/*  {isTrade === false && (*/}
      {/*    <a*/}
      {/*      href={`https://www.carnival.com/cruise-search?pageNumber=1&numadults=2&ptport=CBK&pagesize=8&sort=fromprice&showBest=true&async=true&currency=USD&locality=1`}*/}
      {/*      onClick={() => {*/}
      {/*        triggerGAEvent("explore-sailings");*/}
      {/*        window.gtag("event", "conversion", {*/}
      {/*          allow_custom_scripts: true,*/}
      {/*          u1: "[Number of Passengers]",*/}
      {/*          u10: "[Military]",*/}
      {/*          u11: "[Page URL]",*/}
      {/*          u12: "[ga_cilent_id]",*/}
      {/*          u13: "[vifp_number]",*/}
      {/*          u14: "[Sail ID]",*/}
      {/*          u2: "[Duration]",*/}
      {/*          u3: "[Port]",*/}
      {/*          u4: "[Ship]",*/}
      {/*          u5: "[Destination]",*/}
      {/*          u6: "[Sail Date]",*/}
      {/*          u7: "[Stateroom]",*/}
      {/*          u8: "[Booking ID]",*/}
      {/*          u9: "[Home State]",*/}
      {/*          send_to: "DC-10750860/carni0/carni04l+unique"*/}
      {/*        });*/}
      {/*      }}*/}
      {/*      aria-label="Explore Sailings"*/}
      {/*      className="bg-red uppercase text-white text-[19px] lg:text-[20px] font-bold  leading-none py-3 px-10 pt-3"*/}
      {/*    >*/}
      {/*      Explore&nbsp;Sailings*/}
      {/*    </a>*/}
      {/*  )}*/}
      {/*</div>*/}
    </section>
  );
};

export default ShipView;
